import { Injectable } from '@angular/core';

export type DarkMode = 'on' | 'off' | 'system';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  // FORCE LIGHT MODE - Dark mode is permanently disabled
  private darkMode = false;
  private mode: DarkMode = 'off';

  constructor() {
    this.init();
  }

  getMode() {
    return this.mode;
  }

  async setMode(_mode: DarkMode) {
    // FORCE LIGHT MODE - ignore any mode changes
    this.mode = 'off';
    this.setDarkMode(false);
  }

  async init() {
    // FORCE LIGHT MODE - ignore stored preferences
    this.mode = 'off';
    this.setDarkMode(false);
  }

  checkPrefersColorScheme() {
    // FORCE LIGHT MODE - ignore system preferences
    this.setDarkMode(false);
  }

  isDarkMode() {
    return false; // Always return false
  }

  setDarkMode(_isDarkMode: boolean) {
    // FORCE LIGHT MODE - always remove dark classes
    this.darkMode = false;
    document.body.classList.remove('dark');
    document.documentElement.classList.remove('cc--darkmode');
    document.documentElement.classList.remove('dark');
  }
}
